import RegionModel from 'Models/RegionModel';

const ServerWowClassicModel = {};

// Не забудь обновить бэк.
// @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_WOW -> RegionMap::REGION_ID_EU
ServerWowClassicModel[RegionModel.EU.id] = [
  {
    id: 1,
    title: 'Bonescythe',
  },
  {
    id: 2,
    title: 'Dreadnaught',
  },
  {
    id: 3,
    title: 'Ironfoe',
  },
  {
    id: 4,
    title: 'Kingsfall',
  },
  {
    id: 5,
    title: 'Quel\'Serrar',
  },
];

// Не забудь обновить бэк.
// @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_WOW -> RegionMap::REGION_ID_USA
ServerWowClassicModel[RegionModel.USA.id] = [
  {
    id: 1,
    title: 'Barman Shanker',
  },
  {
    id: 2,
    title: 'Jom Gabbar',
  },
  {
    id: 3,
    title: 'Lionheart',
  },
  {
    id: 4,
    title: 'Mutanus',
  },
  {
    id: 5,
    title: 'Nightfall',
  },
  {
    id: 6,
    title: 'Obsidian Edge',
  },
  {
    id: 7,
    title: 'ShadowStrike',
  },
  {
    id: 8,
    title: 'Swamp of Sorrows',
  },
];

// eslint-disable-next-line import/prefer-default-export
export { ServerWowClassicModel };
